import { APP_ENVIRONMENT } from '../../../types';
import { Authenticator } from '../interface';
import { CodeGrantAuthService } from '../services';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PasswordGrantAuthService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationFacade implements Authenticator {
  private readonly environment = inject(APP_ENVIRONMENT);

  public authenticationChange$: Observable<boolean>;
  private _authenticator: Authenticator;

  constructor() {
    const hasCodeGrant = this.environment.authentication.grants.includes('code');
    this._authenticator = hasCodeGrant ? inject(CodeGrantAuthService) : inject(PasswordGrantAuthService);

    this.authenticationChange$ = this._authenticator.authenticationChange$;
  }

  public authenticate(username?: string, password?: string, releaseCode?: string): Promise<void> {
    return this._authenticator.authenticate(username, password, releaseCode);
  }

  public initialize(): Promise<void> {
    return this._authenticator.initialize();
  }

  public isAuthenticated(): Promise<boolean> {
    return this._authenticator.isAuthenticated();
  }

  public logout(): Promise<void> {
    return this._authenticator.logout();
  }

  public getAccessToken(): Promise<string | undefined> {
    return this._authenticator.getAccessToken();
  }
}
